/**
 * Icon component for rendering SVG icons with customizable size, color, and style.
 * Primarily a response to different icon sets having different SVG characteristics.
 *
 * @param {Object} props - Component props.
 * @param {React.ComponentType} props.Comp - The SVG component to render.
 * @param {number} [props.size=18] - The size of the icon in pixels.
 * @param {string} [props.color="currentColor"] - The color of the icon.
 * @param {boolean} [props.filled=false] - Whether the icon should be filled or outlined.
 * @param {string} [props.className] - Additional CSS class names to apply.
 * @param {Object} [props.style={}] - Additional inline styles to apply.
 * @param {...Object} [props.props] - Additional props to pass to the SVG component.
 * @returns {JSX.Element} The rendered icon component.
 */
import React from "react";
export default function Icon({
  Comp,
  size = 18,
  color = "currentColor",
  filled = false,
  className,
  style = {},
  ...props
}) {
  const svgStyle = { color, ...style };
  if (filled) {
    svgStyle.fill = color;
    svgStyle.stroke = "none";
  } else {
    svgStyle.fill = "none";
    svgStyle.stroke = color;
  }
  return <Comp size={size} className={className} style={svgStyle} {...props} />;
}
